
class AnalyticsHelper {
    static Alias(obj) {
        AnalyticsAlias(obj);
    }
    static Identify(userId, traits, options) {
        AnalyticsIdentify(userId, traits, options);
    }
    static Track(event, data) {
        AnalyticsTrack(event, data);
    }
    static AddSegmentEvent(event) {
        AnalyticsAddSegmentEvent(event);
    }
}

export default AnalyticsHelper;